import { createFileRoute } from '@tanstack/react-router';
import { UsersListPage } from '@/features/settings/users-list-page.js';

export const Route = createFileRoute('/_app/settings/users')({
  component: UsersListPage,
});
